module.exports = __webpack_public_path__ + "img/bluedot.982f7438.png";